<div class="conteiner-modal-incident">
  <h3 mat-dialog-title class="dialog-title">INFORMACION</h3>
  <mat-icon class="close-modal" (click)="dialogRef.close()">close</mat-icon>
</div>

<div class="content__dialog">
  <div class="icon-badge">
    <mat-icon>priority_high</mat-icon>
  </div>

  <mat-dialog-content>
    <p>{{ data.message | uppercase }}</p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="button__container" (click)="dialogRef.close(true)">
      {{ 'aceptar' | uppercase }}
    </button>
  </mat-dialog-actions>
</div>
